module.exports = __webpack_public_path__ + "static/media/11.74e8f269.jpg";